/* @flow */
import { Request } from "shared/src/services/Requests";

const RequestBuilder = new Request.Builder("searchdiscover", "navigationmenu", true);

const service = {
    getNavigationMenu(country: string, locale: string, store: string, customerId: string) {
        return RequestBuilder.path("/menu_structure/country/{country}/locale/{locale}/store/{store}", {
            country,
            locale,
            store
        })
            .query({ customerId })
            .get();
    }
};

export default service;

export const { getNavigationMenu } = service;
